import TourPage from "@/components/TourPage";

export default function GorillaMonkey3Day() {
  return (
    <TourPage
      tourId="rwanda/gorilla-monkey-3-day"
      title="3 Days Rwanda Gorilla and Golden Monkey Trekking Safari"
      duration="3 Days / 2 Nights"
      price="Contact for price"
      image="/goldenmonkeyrwanda.jpeg"
      description="Experience the best of Rwanda's primate encounters with this combined gorilla and golden monkey trekking adventure in Volcanoes National Park."
      itinerary={[
        {
          day: 1,
          title: "Kigali to Volcanoes National Park",
          description: "Travel to the home of mountain gorillas.",
          activities: [
            "Morning pickup from Kigali",
            "Drive to Volcanoes National Park",
            "Visit Ibyiwacu Cultural Village",
            "Evening briefing about gorilla trekking"
          ],
          accommodation: "Mountain Gorilla View Lodge or similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Gorilla Trekking",
          description: "Trek to meet the gentle giants of the forest.",
          activities: [
            "Early morning briefing",
            "Gorilla trekking in the forest",
            "One hour with a gorilla family",
            "Afternoon relaxation at lodge",
            "Cultural entertainment"
          ],
          accommodation: "Mountain Gorilla View Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Golden Monkey Tracking and Return",
          description: "Meet the playful golden monkeys before returning to Kigali.",
          activities: [
            "Golden monkey tracking",
            "Return to Kigali",
            "City tour including Genocide Memorial",
            "Transfer to airport"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Gorilla permit",
        "Golden monkey permit",
        "All ground transportation",
        "English speaking guide",
        "Park entrance fees",
        "Cultural village visit",
        "Accommodation as listed",
        "Meals as specified"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips for guides",
        "Drinks and beverages",
        "Optional activities"
      ]}
    />
  );
}
